import styles from './PageNotFound.module.scss';

const PageNotFound = () => <h1 className={styles.position}>Page Not Found</h1>;

export default PageNotFound;
